import { defineComponent } from 'vue'
import { normalizeExternalUrl, openExternal } from '@/utils/open-external'

/**
 * 外链：渲染成带 href 的 <a>（键盘可达、爬虫可见），点击仍走 openExternal（安卓壳要走原生桥）。
 * rel 带 nofollow：这些多是广告位/友链，原来是 JS 点击、搜索引擎本就看不到，保持不传权重。
 */
export const ExternalAnchor = defineComponent({
  name: 'ExternalAnchor',
  props: { url: { type: String, default: '' } },
  emits: { click: (_e: MouseEvent) => true },
  setup(props, { slots, emit }) {
    return () => (
      <a
        class="btn-reset"
        href={normalizeExternalUrl(props.url) || undefined}
        target="_blank"
        rel="noopener noreferrer nofollow"
        onClick={(e: MouseEvent) => {
          e.preventDefault()
          openExternal(props.url)
          emit('click', e)
        }}
      >
        {slots.default?.()}
      </a>
    )
  },
})
